import { useState, useEffect } from 'react';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navItems = [
    { name: 'Inicio', href: '/#inicio' },
    { name: 'Servicios', href: '/#servicios' },
    { name: 'Casos Clínicos', href: '/casos-clinicos' },
    { name: 'Zonas de Servicio', href: '/zonas-servicio' },
    { name: 'Contacto', href: '/#contacto' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo con H1 para SEO */}
          <div className="flex-shrink-0">
            <a 
              href="/"
              className="flex items-center space-x-3 cursor-pointer"
            >
              <img 
                src="https://static.readdy.ai/image/33540390f643937a387ee69ee6db3814/2107f49c7f66e26bc31712c9355e7f9a.jpeg"
                alt="Logo Pablo Conejero Veterinario"
                className="w-12 h-12 rounded-full object-cover shadow-md"
              />
              <h1 className="text-2xl font-display font-bold">
                <span className={`${isScrolled ? 'text-primary-800' : 'text-white'} transition-colors`}>
                  Pablo Conejero
                </span>
              </h1>
            </a>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            <a
              href="/#inicio"
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled
                  ? 'text-gray-700 hover:text-primary-600'
                  : 'text-white hover:text-accent-400'
              }`}
            >
              Inicio
            </a>
            <a
              href="/#sobre-mi"
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled
                  ? 'text-gray-700 hover:text-primary-600'
                  : 'text-white hover:text-accent-400'
              }`}
            >
              Sobre Mí
            </a>
            <a
              href="/#servicios"
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled
                  ? 'text-gray-700 hover:text-primary-600'
                  : 'text-white hover:text-accent-400'
              }`}
            >
              Servicios
            </a>
            <a
              href="/casos-clinicos"
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled
                  ? 'text-gray-700 hover:text-primary-600'
                  : 'text-white hover:text-accent-400'
              }`}
            >
              Casos Clínicos
            </a>
            <a
              href="/#proceso"
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled
                  ? 'text-gray-700 hover:text-primary-600'
                  : 'text-white hover:text-accent-400'
              }`}
            >
              Proceso
            </a>
            <a
              href="/#preguntas-frecuentes"
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled
                  ? 'text-gray-700 hover:text-primary-600'
                  : 'text-white hover:text-accent-400'
              }`}
            >
              FAQ
            </a>
            <a
              href="/#contacto"
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled
                  ? 'text-gray-700 hover:text-primary-600'
                  : 'text-white hover:text-accent-400'
              }`}
            >
              Contacto
            </a>
            <a
              href="/#contacto"
              className="bg-accent-600 hover:bg-accent-700 text-white px-6 py-2.5 rounded-lg font-semibold transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg"
            >
              <i className="ri-calendar-check-line mr-2"></i>
              Contacto Valoración (24h)
            </a>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden p-2 rounded-lg transition-colors cursor-pointer ${
              isScrolled ? 'text-gray-700 hover:bg-gray-100' : 'text-white hover:bg-white/10'
            }`}
            aria-label="Toggle menu"
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-white border-t border-gray-200 py-4">
            <div className="flex flex-col space-y-4">
              <a
                href="/#inicio"
                className="text-gray-700 hover:text-primary-600 font-medium px-4 py-2 cursor-pointer"
              >
                Inicio
              </a>
              <a
                href="/#sobre-mi"
                className="text-gray-700 hover:text-primary-600 font-medium px-4 py-2 cursor-pointer"
              >
                Sobre Mí
              </a>
              <a
                href="/#servicios"
                className="text-gray-700 hover:text-primary-600 font-medium px-4 py-2 cursor-pointer"
              >
                Servicios
              </a>
              <a
                href="/casos-clinicos"
                className="text-gray-700 hover:text-primary-600 font-medium px-4 py-2 cursor-pointer"
              >
                Casos Clínicos
              </a>
              <a
                href="/#proceso"
                className="text-gray-700 hover:text-primary-600 font-medium px-4 py-2 cursor-pointer"
              >
                Proceso
              </a>
              <a
                href="/#preguntas-frecuentes"
                className="text-gray-700 hover:text-primary-600 font-medium px-4 py-2 cursor-pointer"
              >
                FAQ
              </a>
              <a
                href="/#contacto"
                className="text-gray-700 hover:text-primary-600 font-medium px-4 py-2 cursor-pointer"
              >
                Contacto
              </a>
              <a
                href="/#contacto"
                className="bg-accent-600 hover:bg-accent-700 text-white px-6 py-2.5 rounded-lg font-semibold mx-4 text-center whitespace-nowrap cursor-pointer shadow-lg"
              >
                <i className="ri-calendar-check-line mr-2"></i>
                Contacto Valoración (24h)
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}